import React from 'react';
import './index.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductsOverview from './components/ProductsOverview';
import ProductSection from './components/ProductSection';
import Ingredients from './components/Ingredients';
import FaceWashSection from './components/FaceWashSection';
import OrderSection from './components/OrderSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <ProductsOverview />
          <ProductSection />
          <Ingredients />
          <FaceWashSection />
          <OrderSection />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </LanguageProvider>
  );
}

export default App;
